import script from "./StudentDiscipline.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentDiscipline.vue?vue&type=script&setup=true&lang=js"

import "./StudentDiscipline.vue?vue&type=style&index=0&id=0a161c61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a161c61"]])

export default __exports__